import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { PRIVATE, PUBLIC } from 'router/constants/routes';
import isPrivateRoute from 'router/helpers/isPrivateRoute';

import { getToken, removeToken, setToken } from 'api/utils/tokenManagement';

import {
    authentication,
    authenticationBySignature,
    setAuthenticationStatus,
    setAuthRedirectUrl,
} from 'store/auth/actions';
import { setUrlParams } from 'store/user/actions';

import { accountTabs } from 'constants/account';
import { AUTH_TOKEN_NAME } from 'constants/api';

import { sendAnalyticCabinetStartSession } from 'services/analytics';
import { initAnalytics } from 'services/analytics/initAnalytics';
import { initHotjar } from 'services/Hotjar';

import { useDispatch } from 'hooks/store';

import { getUrlParams } from 'helpers/utils';

const USER_ID_PARAM_NAME = 'c';
const SIGNATURE_PARAM_NAME = 'sg';

export const useAuthentication = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { search, pathname } = useLocation();

    const isPrivate = isPrivateRoute(pathname);

    const params = new URLSearchParams(search);

    useEffect(() => {
        const urlParamsFromURL = getUrlParams();

        const uId = params.get(USER_ID_PARAM_NAME);
        const signature = params.get(SIGNATURE_PARAM_NAME);

        initAnalytics();
        initHotjar();

        sendAnalyticCabinetStartSession();

        if (uId && signature) {
            const subscriptionsPage = `${PRIVATE.ACCOUNT_DEFAULT.path}/${accountTabs.Subscription}`;
            const redirectPage = isPrivate ? pathname : subscriptionsPage;

            dispatch(setAuthRedirectUrl(redirectPage));
            dispatch(
                authenticationBySignature({
                    uId,
                    signature,
                    onSuccess: () => {
                        dispatch(setUrlParams(urlParamsFromURL));

                        navigate(redirectPage);
                    },
                    onError: () => {
                        navigate(PUBLIC.LOGIN.path);
                    },
                })
            );

            return;
        }

        const tokenFromUrl = params.get(AUTH_TOKEN_NAME);

        if (tokenFromUrl) {
            setToken(tokenFromUrl);
        }

        if (!getToken()) {
            isPrivate && dispatch(setAuthRedirectUrl(pathname));

            dispatch(setAuthenticationStatus(false));

            return;
        }

        dispatch(
            authentication({
                onSuccess: () => {
                    navigate(pathname);
                },
                onError: () => {
                    removeToken();
                    isPrivate && dispatch(setAuthRedirectUrl(pathname));
                    navigate(PUBLIC.LOGIN.path);
                },
            })
        );
    }, []);
};
